module.exports = __webpack_public_path__ + "img/product_card_discount_none.a03360fc.png";